module.exports = __webpack_public_path__ + "img/purpose-icon.f15d51b2.png";